function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { flatten, getAnyFromArray } from '@tecsinapse/es-utils';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTheme } from '@material-ui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Tooltip } from '@material-ui/core';
import Help from '@material-ui/icons/Help';
import { MOBILE_COMPONENTS } from "./MobileComponents";
import { WEB_COMPONENTS } from "./WebComponents";
import { calculateValuesSizes } from "./utils/selectHelper";
import FormControl from '@material-ui/core/FormControl';
import { SizeMe } from 'react-sizeme';
import ReactSelect from 'react-select';
import FormHelperText from '@material-ui/core/FormHelperText';

var flattenChildren = function flattenChildren(childrenIn) {
  return childrenIn ? flatten(childrenIn).filter(function (c) {
    return !!c && !!c.props;
  }).map(function (suggestion) {
    return {
      value: suggestion.props.value,
      label: suggestion.props.children,
      disabled: suggestion.props.disabled || false
    };
  }) : [];
};

var isBrowser = typeof window !== 'undefined';
export var SelectUnstyled = function SelectUnstyled(_ref) {
  var labelNotFound = _ref.labelNotFound,
      value = _ref.value,
      _onChange = _ref.onChange,
      _onBlur = _ref.onBlur,
      name = _ref.name,
      children = _ref.children,
      tooltip = _ref.tooltip,
      label = _ref.label,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      endAdornment = _ref.endAdornment,
      classes = _ref.classes,
      disabled = _ref.disabled,
      placeholder = _ref.placeholder,
      touched = _ref.touched,
      _ref$menuPlacement = _ref.menuPlacement,
      menuPlacement = _ref$menuPlacement === void 0 ? 'bottom' : _ref$menuPlacement,
      key = _ref.key,
      fullWidth = _ref.fullWidth,
      warning = _ref.warning,
      error = _ref.error,
      success = _ref.success,
      _ref$isMulti = _ref.isMulti,
      isMulti = _ref$isMulti === void 0 ? false : _ref$isMulti,
      _ref$allowSelectAll = _ref.allowSelectAll,
      allowSelectAll = _ref$allowSelectAll === void 0 ? true : _ref$allowSelectAll,
      _ref$selectPromptMess = _ref.selectPromptMessage,
      selectPromptMessage = _ref$selectPromptMess === void 0 ? 'Selecione' : _ref$selectPromptMess,
      portal = _ref.portal,
      minWidth = _ref.minWidth,
      customAction = _ref.customAction,
      customIndicators = _ref.customIndicators,
      customTextField = _ref.customTextField,
      rest = _objectWithoutProperties(_ref, ["labelNotFound", "value", "onChange", "onBlur", "name", "children", "tooltip", "label", "options", "endAdornment", "classes", "disabled", "placeholder", "touched", "menuPlacement", "key", "fullWidth", "warning", "error", "success", "isMulti", "allowSelectAll", "selectPromptMessage", "portal", "minWidth", "customAction", "customIndicators", "customTextField"]);

  var valuesAllSelected = isMulti && value && value.length === options.length;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      menuIsOpen = _useState2[0],
      setMenuIsOpen = _useState2[1];

  var _useState3 = useState(valuesAllSelected),
      _useState4 = _slicedToArray(_useState3, 2),
      allSelected = _useState4[0],
      setAllSelected = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      containerSize = _useState6[0],
      setContainerSize = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      yPos = _useState8[0],
      setYPos = _useState8[1];

  var variant = rest.variant;
  var selectRef = useRef();
  var theme = useTheme();
  var matches = useMediaQuery(theme.breakpoints.up('sm'));

  if (variant === 'auto') {
    if (!matches) {
      variant = 'mobile';
    } else {
      variant = 'web';
    }
  }

  useEffect(function () {
    var pos = selectRef.current.getBoundingClientRect();
    setYPos(pos.y);
  }, []);
  var map = useMemo(function () {
    return options !== undefined && options && options.length !== 0 ? options : flattenChildren(children);
  }, [options, children]);

  var defaultProps = _objectSpread(_objectSpread({
    labelNotFound: labelNotFound,
    yPos: yPos,
    selectPromptMessage: selectPromptMessage,
    isMulti: isMulti,
    menuIsOpen: menuIsOpen,
    setMenuIsOpen: setMenuIsOpen,
    minWidth: minWidth,
    value: !isMulti ? getAnyFromArray(map.filter(function (c) {
      return c.value === value;
    })) : map.filter(function (c) {
      return value.includes(c.value);
    }),
    isDisabled: disabled,
    options: map,
    className: classes.select,
    childrenClasses: classes,
    placeholder: placeholder || label || '',
    label: label,
    textFieldProps: _objectSpread({
      label: label,
      disabled: disabled,
      error: error,
      classes: classes,
      warning: warning,
      InputLabelProps: {
        shrink: true,
        classes: {
          outlined: classes.noZIndex
        }
      }
    }, customTextField),
    name: name,
    allSelected: allSelected,
    allowSelectAll: allowSelectAll,
    meta: {
      touched: touched,
      error: error
    },
    hideSelectedOptions: false,
    endAdornment: /*#__PURE__*/React.createElement(React.Fragment, null, endAdornment, tooltip ? /*#__PURE__*/React.createElement(Tooltip, {
      title: tooltip,
      placement: "right"
    }, /*#__PURE__*/React.createElement(Help, null)) : null),
    onChange: function onChange(input2) {
      if (setMenuIsOpen !== undefined && !isMulti) {
        setMenuIsOpen(false);
      }

      if (isMulti) {
        setAllSelected(input2 instanceof Array && input2.map(function (c) {
          return c.value;
        }).length === map.length);
      }

      var emptyValue = isMulti ? [] : '';
      var inputValue = input2 ? input2.value : emptyValue;

      _onChange(input2 instanceof Array ? input2.map(function (c) {
        return c.value;
      }) : inputValue);
    },
    onBlur: function onBlur(event) {
      if (_onBlur) {
        _onBlur(event);
      }

      setMenuIsOpen(false);
    },
    selectAll: function selectAll(event) {
      if (!document.getElementById('customAction').contains(event.target)) {
        _onChange(!allSelected ? options.map(function (c) {
          return c.value;
        }) : []);

        setAllSelected(!allSelected);
      }
    }
  }, rest), {}, {
    variant: variant,
    containerSize: containerSize,
    setContainerSize: setContainerSize,
    customAction: customAction,
    customIndicators: customIndicators
  });

  var selectProps = variant === 'mobile' ? _objectSpread({
    components: MOBILE_COMPONENTS,
    menuPortalTarget: isBrowser ? document.body : null,
    backspaceRemovesValue: false,
    deleteRemovesValue: false
  }, defaultProps) : _objectSpread(_objectSpread({
    menuPlacement: menuPlacement
  }, portal && {
    styles: {
      menuPortal: function menuPortal(base) {
        return _objectSpread(_objectSpread({}, base), {}, {
          zIndex: 9999
        });
      }
    },
    menuPortalTarget: isBrowser ? document.body : null
  }), {}, {
    components: WEB_COMPONENTS
  }, defaultProps);
  var valuesWidth = useMemo(function () {
    return calculateValuesSizes(selectProps.options);
  }, [selectProps.options]);
  var style = {
    minWidth: minWidth
  };
  return isBrowser && /*#__PURE__*/React.createElement("div", {
    ref: selectRef
  }, /*#__PURE__*/React.createElement(FormControl, {
    key: key,
    error: !!error,
    fullWidth: fullWidth,
    style: style
  }, /*#__PURE__*/React.createElement(SizeMe, {
    noPlaceholder: true
  }, function (_ref2) {
    var size = _ref2.size;
    return /*#__PURE__*/React.createElement(ReactSelect, _extends({}, selectProps, {
      valuesWidth: valuesWidth,
      selectSize: size
    }));
  }), error && /*#__PURE__*/React.createElement(FormHelperText, null, error)));
};
export default SelectUnstyled;